<template>
  <transition name="fade">
    <div class="logo-loading" v-if="loadEnd">
      <img @load="downloadFinished" @error="downloadFinished" style="width:0;height:0;" :src="`/static/img/loading.gif`" />
      <div class="load-wrap">
        <div class="h-line bottom"></div>
        <div class="h-line top"></div>
        <div class="v-line right"></div>
        <div class="v-line left"></div>
        <img v-if="loadStart" :src="`/static/img/loading.gif?${Math.random()}`">
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data: _ => ({
    loadStart: false,
    loadEnd: true
  }),
  methods: {
    downloadFinished () {
      this.loadStart = true
    }
  },
  watch: {
    loadStart (val) {
      setTimeout(_ => {
        this.loadEnd = false
      }, 3400)
    }
  }
}
</script>

<style lang="scss" scoped>
.logo-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 1);
  z-index: 22;
  .load-wrap {
    position: relative;
    display: inline-block;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .h-line{
      position: absolute;
      width: 100%;
      height: 5px;
      z-index: 1;
      background: #000;
      &.top{
        top: 0
      }
      &.bottom{
        bottom: 0
      }
    }
    .v-line{
      position: absolute;
      width: 5px;
      height: 100%;
      z-index: 1;
      background: #000;
      &.left{
        left: 0
      }
      &.right{
        right: 0
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-leave-to {
  opacity: 0;
}

.fade-enter {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/LoadingLogo.vue